export default __webpack_public_path__ + "static/media/client1.d296ae9b.png";